import { ActivatedRoute } from '@angular/router';
import { createAction, props } from '@ngrx/store';

import { NotesFiltersInterface } from '@modules/notes/filters-store/notes-filters.service';

export const upsertNotesFilters = createAction('[Notes Filters] Upsert', props<{ notesFilters: Partial<NotesFiltersInterface> }>());

export const upsertNotesFiltersSuccess = createAction(
  '[Notes Filters] Upsert success',
  props<{ notesFilters: Partial<NotesFiltersInterface> }>(),
);

export const getNotesFiltersFromLocalStorage = createAction(
  '[Notes Filters] Get From Local Storage',
  props<{ defaultNoteFilter: NotesFiltersInterface; route: ActivatedRoute; isWidgetView: boolean }>(),
);

export const setActiveNotesFiltersId = createAction('[Notes Filters] Set Active Filters Id', props<{ notesFiltersId: string }>());
